import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { BasicTopBar } from "components/layout";
import "./Layouts.css";

export function UnauthenticatedPage(props) {
    return (
        <Fragment>
            <BasicTopBar />
            <div id="main-container" className="unauthenticated">
                {props.children}
            </div>
        </Fragment>
    );
}

UnauthenticatedPage.propTypes = {
    children: PropTypes.node.isRequired
};